import React, { useState } from 'react';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import styles from 'src/asset/scss/style/market.detail.module.scss';
//store
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import useMarketHook from 'src/webapp/hooks/market/market.hook';
import { useNavigate, useParams } from 'react-router-dom';

export default function MarketDetailInfo(props) {
    const navigator = useNavigate();
    const params = useParams();
    const { data } = props;//props
    const { partner } = usePartnerStore();
    const { marketUpdateAndDeleteAPI } = useMarketHook();

    /* =============== 게시글 버튼목록 =============== */
    const buttonList = [{name: data.STATUS === '2' ? "거래가능" :'예약중', style:null},{name:'거래완료', style:null},{name:'게시글 수정', style:null},{name:'삭제', style:styles.pointColor}];
    const buttonFilter = (idx) => {
        if(idx === 0 && (data.STATUS !== '1' && data.STATUS !== '2')) { return false; }
        if(idx === 1 && (data.STATUS !== '1' && data.STATUS !== '2')) { return false; }
        return true;
    }
    /* =============== 게시글 버튼목록 =============== */
    /* =============== 게시글 수정 및 삭제 버튼토글여부 =============== */
    const [ toggle,setToggle ] = useState(false);
    const onToggleHandler = () => {
        setToggle(!toggle);
    }
    /* =============== 게시글 수정 및 삭제 버튼토글여부 =============== */
    return (
        <Element tag={`div`} className={styles.detailContainer}>
            <Element tag={`div`} className={styles.priceArea}>
                <Element tag={`div`}>
                    <Element tag={`p`}><Element tag={`label`}>구매가</Element><Element tag={`small`}>{data.INIT_PRICE}원</Element></Element>
                    <Element tag={`h1`}><Element tag={`strong`}>{data.DISCOUNT}%</Element><Element tag={`span`}>{data.CURR_PRICE}원</Element></Element>
                </Element>
                {data.PARTNER_CD == partner.COMN_CD ?
                    <Element tag={`div`} className={styles.btnArea}>
                        <Element tag={`button`} anyprop={(e) => onToggleHandler()} className={styles.btnUpdate}><FontAwesomeIcon icon="fa-solid fa-ellipsis-vertical" /></Element>
                        {toggle ?
                            <Element tag={`ul`}>
                                {buttonList.map((item, idx) => 
                                    (buttonFilter(idx) ? 
                                        <Element tag={`li`} key={idx} anyprop={(e) => {onToggleHandler(); idx === 0 || idx === 3 ? marketUpdateAndDeleteAPI((idx === 0 ? (item.name == "거래가능" ? "1": item.name == "예약중" ? "2" : null) : idx === 3 ? "3" : null), data) : idx === 2 ? navigator(`/market/update/${params.seq}`, {state:data}) : props.onDismiss("success", true)}} className={item.style}><Element tag={`span`}>{item.name}</Element></Element>
                                    : null)
                                )}
                            </Element>
                        : null}
                    </Element>
                : null}
            </Element>
            <Element tag={`div`} className={styles.contentArea}>
                <Element tag={`h1`}>{data.SUBJECT}</Element>
                <Element tag={`pre`}>{data.CONT}</Element>
            </Element>
            <Element tag={`div`} className={styles.btnArea} anyprop={(e) => props.onContract()}>
                <button disabled={props.disabled()}><a href={!props.disabled() ? `tel:+82${data.TEL_NO}` : null}><Element tag={`span`}>{props.onStatusFilter()}</Element></a></button>
            </Element>
            <Element tag={`div`} className={styles.partnerInfoArea}>
                <Element tag={`div`} className={styles.imgArea}><img src={`${process.env.REACT_APP_IMAGE_URL + data.PARTNER_IMG_SRC}`} alt={data.PARTNER_NAME} /></Element>
                <Element tag={`div`} className={styles.partnerInfo}>
                    <Element tag={`h1`}>{data.PARTNER_NAME}</Element>
                    <Element tag={`p`}>{data.PARTNER_ADDR}</Element>
                </Element>
            </Element>
        </Element>
    );
}